import { ChallengesList } from '@/components/challenges/ChallengesList';
import { LibraryMapEditor } from '@/components/challenges/LibraryMapEditor';
import { MapViewToggle, type MapView } from '@/components/shared/map/MapViewToggle';
import { PageContainer, useApp } from '@startupquickstart/frontend';
import { useState } from 'react';

const breadcrumbs = [
  { label: 'Home', href: '/' },
  { label: 'Challenge Library', current: true },
];

export function ChallengesPage() {
  const { config } = useApp();
  const [view, setView] = useState<MapView>('list');

  return (
    <PageContainer>
      <ChallengesList
        breadcrumbs={breadcrumbs}
        headerRight={<MapViewToggle view={view} onViewChange={setView} />}
        contentOverride={
          view === 'map' ? <LibraryMapEditor googleMapsApiKey={config?.googleMapsApiKey} /> : undefined
        }
      />
    </PageContainer>
  );
}
